import { Flex } from "@mantine/core";
import { IconMoustache } from "@tabler/icons-react";
import "./AiAvatar.css";

export function AiAvatar({ size = 60 }: { size?: number }) {
  return (
    <Flex
      pos="relative"
      w={size}
      h={size}
      align="center"
      justify="center"
      style={{ "--avatar-size": `${size}px` } as React.CSSProperties}
    >
      <IconMoustache stroke={1} size={size / 1.5} />
    </Flex>
  );
}
